export default "__VITE_ASSET__n1V3FX_3__"